/**
 * @generated SignedSource<<21595b52eae1d880a08dd5a086ae868f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CatalogHotspot_catalogPage$data = {
  readonly title: string | null;
  readonly type: string | null;
  readonly " $fragmentType": "CatalogHotspot_catalogPage";
};
export type CatalogHotspot_catalogPage$key = {
  readonly " $data"?: CatalogHotspot_catalogPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"CatalogHotspot_catalogPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CatalogHotspot_catalogPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "type": "CatalogPage",
  "abstractKey": null
};

(node as any).hash = "2980d6b03c646e9b0c974a5ab54a0025";

export default node;
